// StockPeersList.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { StockPeersCards } from "@/src/components/companies/StockPeers";
import StockPeersCardSkeleton from "@/src/components/companies/StockPeersCardSkeleton";
import Link from "next/link";

const formatCompanyNameForUrl = (name) => {
  return name
    .toLowerCase()
    .replace(/[.,]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-");
};

const StockPeersList = ({ ticker, sections }) => {
  const [peers, setPeers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPeers = async () => {
      try {
        const response = await axios.post(
          "/api/company/stock-peers",
          { ticker },
          { headers: { "Content-Type": "application/json" } }
        );

        if (Array.isArray(response.data) && response.data.length > 0) {
          const peersList = response.data[0].peersList;
          if (Array.isArray(peersList)) {
            const peersWithNames = await Promise.all(
              peersList.map(async (peerTicker) => {
                const peerResponse = await axios.post(
                  "/api/company/details",
                  { ticker: peerTicker },
                  { headers: { "Content-Type": "application/json" } }
                );
                const peerData = peerResponse.data[0];
                return { ticker: peerTicker, name: peerData.companyName };
              })
            );
            setPeers(peersWithNames);
          } else {
            setPeers([]);
          }
        } else {
          setPeers([]);
        }
      } catch (error) {
        console.error("Failed to fetch stock peers");
        setPeers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPeers();
  }, [ticker]);

  return (
    <>
      <section
        id="comparables"
        className="p-5 mb-6 bg-white border shadow-md rounded-lg"
      >
        <h2 className="text-xl font-semibold mb-4">Comparables</h2>
        <div className="overflow-x-auto whitespace-nowrap">
          {loading ? (
            <div className="flex space-x-4">
              {[...Array(4)].map((_, index) => (
                <StockPeersCardSkeleton key={index} />
              ))}
            </div>
          ) : peers.length > 0 ? (
            peers.map((peer) => (
              <div key={peer.ticker} className="inline-block mt-5 mx-2">
                <Link
                  href={`/stocks/${peer.ticker}/${formatCompanyNameForUrl(
                    peer.name
                  )}`}
                  className="cursor-pointer"
                >
                  <StockPeersCards ticker={peer.ticker} />
                </Link>
              </div>
            ))
          ) : (
            <p>No peers found.</p>
          )}
        </div>
      </section>
    </>
  );
};

export default StockPeersList;
